import React, { useEffect, useState } from 'react';

/**
 * OnGlowyticsOffer: On Türkiye için 2 slaytlık Glowytics kullanım + GA4 Web Entegrasyonu teklifi (Platform · Ücret). Performans hizmeti yok.
 * Route: /hq/on-glowytics (ProtectedRoute allowEmails, sadece sahibine açık)
 *
 * Belge iframe srcDoc içinde çalışır; kendi `@page`, `:root` ve body kuralları panele sızmasın diye.
 * HTML modülü dinamik yüklenir, ana bundle'a girmez.
 */
export default function OnGlowyticsOffer() {
  const [html, setHtml] = useState(null);

  useEffect(() => {
    let alive = true;
    import('./onGlowyticsHtml')
      .then((mod) => {
        if (alive) setHtml(mod.default);
      })
      .catch(() => {
        if (alive) setHtml('<p style="font:14px sans-serif;padding:24px">Teklif yüklenemedi.</p>');
      });
    return () => {
      alive = false;
    };
  }, []);

  const fill = { position: 'fixed', inset: 0, width: '100vw', height: '100vh', border: 0 };

  if (!html) return <div style={{ ...fill, background: '#E7E7EC' }} />;

  return <iframe title="On Türkiye · Glowytics teklif" srcDoc={html} style={fill} />;
}
